import { createSelector } from 'reselect';

import { getAssignmentHashKey } from '@components/status-cell/helpers';
import { ACCURACY } from '@components/accuracy-progress-toggle/accuracy-progress-constants';

export const getAssignments = state => state.entitiesReducer.assignments;
export const getLearningJourneys = state => state.entitiesReducer.learningJourneys;
export const getCurrentFilter = state => state.UPFAssignReducer.accuracyProgressToggle.currentFilter;

export const collapsedAccuracyResultsSelector = (sortedStudentIds, learningJourneyIds) =>
  createSelector([getAssignments], assignments =>
    sortedStudentIds.map(studentId => {
      let accuracyTotal = 0;
      let resultCount = 0;

      learningJourneyIds.forEach(learningJourneyId => {
        const assignmentHashKey = getAssignmentHashKey(studentId, learningJourneyId);
        const assignment = assignments[assignmentHashKey];
        const { resultStepsCompleted = 0, resultAccuracy = 0 } = assignment || {};

        if (resultStepsCompleted > 0) {
          accuracyTotal += resultAccuracy;
          resultCount += 1;
        }
      });

      const averageAccuracy = resultCount > 0 ? Number((accuracyTotal / resultCount).toFixed(0)) : 0;

      return { id: studentId, value: `${averageAccuracy}%`, showResult: resultCount > 0 };
    })
  );

export const collapsedProgressResultsSelector = (sortedStudentIds, learningJourneyIds) =>
  createSelector([getAssignments, getLearningJourneys], (assignments, learningJourneys) =>
    sortedStudentIds.map(studentId => {
      let stepCountTotal = 0;
      let stepCompletedTotal = 0;

      learningJourneyIds.forEach(learningJourneyId => {
        const assignmentHashKey = getAssignmentHashKey(studentId, learningJourneyId);
        const assignment = assignments[assignmentHashKey];
        const { resultStepsCompleted = 0 } = assignment || {};
        const learningJourney = learningJourneys[learningJourneyId] || {};
        const { childTopics: learningJourneyStepIds = [] } = learningJourney;

        stepCountTotal += learningJourneyStepIds.length;
        stepCompletedTotal += resultStepsCompleted;
      });

      return { id: studentId, value: `${stepCompletedTotal}/${stepCountTotal}`, showResult: stepCountTotal > 0 };
    })
  );

export const collapsedResultsSelector = (sortedStudentIds, learningJourneyIds) =>
  createSelector(
    [
      getCurrentFilter,
      collapsedAccuracyResultsSelector(sortedStudentIds, learningJourneyIds),
      collapsedProgressResultsSelector(sortedStudentIds, learningJourneyIds)
    ],
    (currentFilter, accuracyResults, progressResults) => {
      if (currentFilter === ACCURACY) {
        return accuracyResults;
      }

      return progressResults;
    }
  );



// WEBPACK FOOTER //
// ./components/grid/collapsed/selectors.js